import { api } from 'helpers'
import { ISchool, IFeature, IUpdateSchoolFeatures } from '../types'

export const featureFlagsService = {
  async getSchools(): Promise<ISchool[]> {
    const response = await api.get('/api/arc_mosaico/schools')
    return response.data.schools || []
  },

  async getGlobalFeatures(): Promise<IFeature[]> {
    const response = await api.get('/api/arc_mosaico/features')
    const features = response.data.features || []
    // Transforma array de strings em array de objetos { key: string }
    return features.map((feature: string) => ({ key: feature }))
  },

  async addSchoolFeatures(data: IUpdateSchoolFeatures): Promise<void> {
    await api.post(`/api/arc_mosaico/features/schools/${data.school_id}`, {
      features: data.features,
    })
  },

  async removeSchoolFeatures(data: IUpdateSchoolFeatures): Promise<void> {
    await api.delete(`/api/arc_mosaico/features/schools/${data.school_id}`, {
      data: {
        features: data.features,
      },
    })
  },
}
